module.exports = __webpack_public_path__ + "static/media/remind.e30aa0e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/remind.mp3
// module id = WpsI
// module chunks = 3